import type { Work } from "@/types";

export const works: Work[] = [
  {
    id: "w-1001",
    title: "星河彼岸",
    enTitle: "Across the Starry Shore",
    type: "movie",
    genre: ["科幻", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%2C%20deep%20crimson%20and%20orange%20nebula%2C%20dramatic%20rim%20light%2C%20minimal%20composition%2C%20high%20detail%20editorial%20poster%20art&width=600&height=900&seq=txw-star-cover-01&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20of%20a%20spaceship%20silhouette%20crossing%20a%20vast%20crimson%20and%20orange%20nebula%2C%20glowing%20planet%20horizon%2C%20cinematic%20wide%20shot%2C%20warm%20dramatic%20lighting%2C%20deep%20space%20atmosphere&width=1600&height=900&seq=txw-star-poster-01&orientation=landscape",
    summary:
      "一艘满载希望的星际方舟驶向未知星系，船长在漫长的航程中逐渐发现，真正的彼岸并不在星空尽头，而在每个人心底那段无法割舍的记忆。影片以宏大的宇宙想象包裹细腻的情感内核，讲述关于离别、守护与重逢的故事。",
    director: "顾清野",
    cast: ["林知远", "乔星晚", "程野", "苏木"],
    duration: "片长 148 分钟",
    updateTime: "2025-10-14T09:30:00",
    views: 128600,
    featured: true,
  },
  {
    id: "w-1002",
    title: "山海拾光",
    enTitle: "Light of Mountains and Seas",
    type: "movie",
    genre: ["动画", "奇幻"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20of%20a%20young%20girl%20riding%20a%20mythical%20winged%20beast%20through%20glowing%20mountains%2C%20warm%20orange%20and%20rose%20color%20palette%2C%20painterly%20illustration%2C%20cinematic%20poster%20composition&width=600&height=900&seq=txw-shanhai-cover-02&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20animated%20landscape%20of%20floating%20mythical%20mountains%20and%20a%20sea%20of%20glowing%20clouds%2C%20warm%20sunset%20orange%20tones%2C%20epic%20fantasy%20wide%20shot%2C%20artistic%20illustration&width=1600&height=900&seq=txw-shanhai-poster-02&orientation=landscape",
    summary:
      "取材于上古神话的少年成长故事。失去记忆的小女孩与一只受伤的神兽结伴同行，穿越山海之间寻找传说中的拾光之树，途中遇见形形色色的旅人，也一点点找回属于自己的名字与来处。",
    director: "叶千秋",
    cast: ["配音：夏小满", "配音：陆川", "配音：白鹿"],
    duration: "片长 112 分钟",
    updateTime: "2025-10-13T14:10:00",
    views: 96400,
    featured: false,
  },
  {
    id: "w-1003",
    title: "长夜将明",
    enTitle: "Before the Dawn",
    type: "movie",
    genre: ["悬疑", "犯罪"],
    region: "中国香港",
    year: 2024,
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%2C%20silhouette%20of%20a%20detective%20under%20a%20single%20street%20lamp%20in%20heavy%20rain%2C%20dark%20moody%20tone%20with%20a%20warm%20amber%20highlight%2C%20minimal%20cinematic%20composition&width=600&height=900&seq=txw-dawn-cover-03&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20street%20in%20a%20crime%20thriller%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20lone%20figure%20walking%20away%2C%20moody%20amber%20and%20deep%20shadow%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-dawn-poster-03&orientation=landscape",
    summary:
      "一桩尘封十二年的悬案重新浮出水面，老刑警与年轻记者在层层迷雾中抽丝剥茧。真相越近，危险越深——当长夜即将天明，究竟谁在守护，谁又在掩盖。",
    director: "麦兆烽",
    cast: ["梁家诚", "周文靖", "许志远"],
    duration: "片长 126 分钟",
    updateTime: "2025-09-28T11:00:00",
    views: 87200,
    featured: false,
  },
  {
    id: "w-1004",
    title: "人间烟火味",
    enTitle: "Taste of Ordinary Days",
    type: "movie",
    genre: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20movie%20poster%2C%20a%20small%20family%20gathering%20around%20a%20steaming%20dinner%20table%20in%20a%20cozy%20old%20kitchen%2C%20golden%20warm%20light%2C%20gentle%20emotional%20tone%2C%20cinematic%20poster&width=600&height=900&seq=txw-fire-cover-04&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20old%20Chinese%20kitchen%20with%20steaming%20dishes%20and%20warm%20lantern%20light%2C%20family%20dining%20scene%2C%20golden%20evening%20tones%2C%20nostalgic%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-fire-poster-04&orientation=landscape",
    summary:
      "一家开了三十年的老面馆即将拆迁，店主夫妇与三个性格迥异的儿女不得不在离别前，重新坐回同一张饭桌。一饭一蔬之间，藏着一个普通家庭最真实的欢喜与遗憾。",
    director: "何静之",
    cast: ["王建军", "李慧兰", "王梓萱", "王浩宇"],
    duration: "片长 118 分钟",
    updateTime: "2025-10-11T16:40:00",
    views: 73500,
    featured: false,
  },
  {
    id: "w-1005",
    title: "极速边界",
    enTitle: "Speed Limit",
    type: "movie",
    genre: ["动作", "赛车"],
    region: "中国大陆",
    year: 2024,
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=High%20energy%20racing%20action%20movie%20poster%2C%20a%20sleek%20race%20car%20drifting%20through%20a%20night%20city%20with%20sparks%20and%20motion%20blur%2C%20vivid%20crimson%20and%20orange%20highlights%2C%20dynamic%20cinematic%20composition&width=600&height=900&seq=txw-speed-cover-05&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Night%20street%20racing%20scene%20with%20glowing%20red%20tail%20lights%20and%20speed%20motion%20blur%2C%20rain%20slick%20asphalt%2C%20high%20octane%20cinematic%20wide%20shot%2C%20warm%20neon%20tones&width=1600&height=900&seq=txw-speed-poster-05&orientation=landscape",
    summary:
      "退役车手为了替师父还清债务重返赛道，却卷入一场横跨城市的非法竞速。油门踩到底的每一秒，都是在速度与底线之间做出选择。",
    director: "陈锋",
    cast: ["赵文轩", "金智勋", "钱小雨"],
    duration: "片长 104 分钟",
    updateTime: "2025-08-22T10:20:00",
    views: 68100,
    featured: false,
  },
  {
    id: "w-1006",
    title: "再见，昨日",
    enTitle: "See You, Yesterday",
    type: "movie",
    genre: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20two%20people%20standing%20back%20to%20back%20at%20sunset%20on%20an%20empty%20train%20platform%2C%20soft%20rose%20and%20warm%20orange%20sky%2C%20tender%20melancholic%20tone%2C%20minimal%20composition&width=600&height=900&seq=txw-yesterday-cover-06&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Empty%20railway%20platform%20at%20golden%20sunset%2C%20lone%20figure%20with%20a%20suitcase%2C%20warm%20rose%20and%20orange%20sky%2C%20bittersweet%20romantic%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-yesterday-poster-06&orientation=landscape",
    summary:
      "如果能回到昨天，你最想改变什么？一段被时间反复折叠的爱情里，两个人一次次相遇又一次次告别，直到终于明白，有些遗憾本身就是答案。",
    director: "苏晚",
    cast: ["顾南", "许清欢"],
    duration: "片长 122 分钟",
    updateTime: "2025-10-09T20:00:00",
    views: 79900,
    featured: false,
  },
  {
    id: "w-2001",
    title: "京华烟云录",
    enTitle: "Chronicles of the Capital",
    type: "tv",
    genre: ["古装", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20elegant%20lady%20in%20traditional%20crimson%20embroidered%20robe%20standing%20in%20a%20palace%20corridor%2C%20ornate%20architecture%2C%20warm%20lantern%20light%2C%20refined%20cinematic%20composition&width=600&height=900&seq=txw-jinghua-cover-07&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%20with%20hanging%20lanterns%2C%20misty%20atmosphere%2C%20warm%20crimson%20and%20gold%20tones%2C%20epic%20period%20drama%20wide%20shot&width=1600&height=900&seq=txw-jinghua-poster-07&orientation=landscape",
    summary:
      "民国初年，江南望族沈家的两位小姐在时代洪流中走上截然不同的道路。家族兴衰、家国动荡、爱恨纠葛交织成一幅恢弘的时代画卷。全剧共 42 集。",
    director: "郑佩瑜",
    cast: ["孙可盈", "江疏影", "陈屿", "李承泽"],
    duration: "全 42 集",
    updateTime: "2025-10-15T08:00:00",
    views: 156200,
    featured: true,
  },
  {
    id: "w-2002",
    title: "城市之光",
    enTitle: "City Lights",
    type: "tv",
    genre: ["都市", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20mystery%20drama%20poster%2C%20a%20young%20detective%20standing%20on%20a%20high%20building%20at%20night%20overlooking%20a%20glowing%20city%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20cinematic%20poster&width=600&height=900&seq=txw-city-cover-08&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Night%20cityscape%20of%20a%20modern%20metropolis%20from%20above%2C%20warm%20amber%20street%20lights%20against%20deep%20shadows%2C%20cinematic%20moody%20wide%20shot%2C%20urban%20mystery%20atmosphere&width=1600&height=900&seq=txw-city-poster-08&orientation=landscape",
    summary:
      "一名因旧案背负心结的刑警调任新城区，接连发生的离奇案件将他与神秘的心理侧写师紧紧绑在一起。城市的霓虹之下，每一盏灯背后都藏着不愿被照亮的故事。",
    director: "费正清",
    cast: ["霍云深", "宋佳宁", "黄志远"],
    duration: "更新至 24 集",
    updateTime: "2025-10-15T20:30:00",
    views: 142800,
    featured: false,
  },
  {
    id: "w-2003",
    title: "长安夜行",
    enTitle: "Night Walk in Chang'an",
    type: "tv",
    genre: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mystery%20drama%20poster%2C%20a%20figure%20in%20flowing%20robes%20with%20a%20lantern%20walking%20a%20moonlit%20old%20street%2C%20warm%20lantern%20glow%20against%20cool%20night%2C%20cinematic%20composition&width=600&height=900&seq=txw-changan-cover-09&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Moonlit%20ancient%20Chinese%20city%20street%20with%20lanterns%20and%20wooden%20architecture%2C%20mysterious%20mist%2C%20warm%20amber%20glow%2C%20cinematic%20period%20drama%20wide%20shot&width=1600&height=900&seq=txw-changan-poster-09&orientation=landscape",
    summary:
      "盛唐长安城，一名掌管夜间巡防的小吏，因一连串诡异的失窃案卷入皇城深处的权力漩涡。白日繁华太平，夜色之下暗流涌动。",
    director: "沈砚舟",
    cast: ["顾云归", "陆明川", "白若溪"],
    duration: "全 36 集",
    updateTime: "2025-07-18T12:00:00",
    views: 118900,
    featured: false,
  },
  {
    id: "w-2004",
    title: "我们的十年",
    enTitle: "Our Ten Years",
    type: "tv",
    genre: ["年代", "情感"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20era%20drama%20poster%2C%20group%20of%20young%20friends%20on%20the%20rooftop%20of%20an%20old%20residential%20building%20at%20golden%20sunset%2C%20warm%20sepia%20tones%2C%20emotional%20cinematic%20composition&width=600&height=900&seq=txw-tenyears-cover-10&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Old%20Chinese%20residential%20neighborhood%20at%20sunset%2C%20laundry%20lines%20and%20bicycles%2C%20warm%20nostalgic%20sepia%20tones%2C%20heartwarming%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-tenyears-poster-10&orientation=landscape",
    summary:
      "从上世纪九十年代的一座老厂区家属院讲起，五个从小一起长大的伙伴走过青春、离别与重逢。十年如梦，他们把彼此的名字写进了各自的人生。",
    director: "田晓冬",
    cast: ["韩晓峰", "林雨桐", "孟迟", "何知秋"],
    duration: "全 40 集",
    updateTime: "2025-10-12T19:00:00",
    views: 103500,
    featured: false,
  },
  {
    id: "w-2005",
    title: "深海回声",
    enTitle: "Echoes of the Deep",
    type: "tv",
    genre: ["科幻", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20series%20poster%2C%20deep%20sea%20diver%20silhouette%20before%20a%20glowing%20mysterious%20structure%2C%20dark%20turquoise%20water%20with%20warm%20orange%20light%20beams%2C%20cinematic%20tension&width=600&height=900&seq=txw-deep-cover-11&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20with%20glowing%20mysterious%20ancient%20structure%2C%20light%20beams%20cutting%20through%20dark%20water%2C%20warm%20orange%20accents%2C%20cinematic%20sci-fi%20wide%20shot&width=1600&height=900&seq=txw-deep-poster-11&orientation=landscape",
    summary:
      "一支深海科考队在马里亚纳海沟深处捕捉到一段无法解释的声波。随着调查深入，队员们发现，那个回应的源头也许并不来自海底。",
    director: "骆星宸",
    cast: ["秦朗", "柳青梧", "夏书言"],
    duration: "全 28 集",
    updateTime: "2025-10-14T21:00:00",
    views: 92700,
    featured: false,
  },
  {
    id: "w-2006",
    title: "春日迟迟",
    enTitle: "Late Spring Days",
    type: "tv",
    genre: ["爱情", "都市"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20romance%20drama%20poster%2C%20a%20young%20woman%20tending%20flowers%20in%20a%20sunlit%20cafe%2C%20soft%20blanket%20of%20spring%20light%2C%20pink%20and%20warm%20orange%20tones%2C%20gentle%20cinematic%20composition&width=600&height=900&seq=txw-spring-cover-12&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Sunlit%20cozy%20cafe%20with%20flower%20vases%20and%20warm%20spring%20light%20through%20large%20windows%2C%20soft%20pink%20and%20orange%20tones%2C%20heartwarming%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-spring-poster-12&orientation=landscape",
    summary:
      "失业又失恋的设计师回到故乡小城，接手母亲快要倒闭的花店。在四季流转里，她慢慢找回了对生活的热爱，也遇见了那个愿意陪她等花开的人。",
    director: "高念",
    cast: ["温以宁", "时予", "许安"],
    duration: "全 32 集",
    updateTime: "2025-06-30T15:00:00",
    views: 88000,
    featured: false,
  },
  {
    id: "w-3001",
    title: "星光大赏",
    enTitle: "Starlight Awards",
    type: "variety",
    genre: ["音乐", "竞技"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20variety%20show%20poster%2C%20singer%20silhouette%20on%20a%20glowing%20stage%20surrounded%20by%20warm%20crimson%20and%20orange%20spotlights%2C%20confetti%2C%20energetic%20cinematic%20composition&width=600&height=900&seq=txw-starlight-cover-13&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20warm%20crimson%20and%20orange%20spotlights%2C%20large%20audience%20silhouettes%2C%20glittering%20energy%2C%20cinematic%20concert%20wide%20shot&width=1600&height=900&seq=txw-starlight-poster-13&orientation=landscape",
    summary:
      "年度最具影响力的音乐竞演舞台，四支战队火力全开，用声音点燃整个夏天。导师阵容重磅集结，每期都有惊喜合作舞台与现场乐队的沉浸式呈现。",
    director: "综艺制作中心",
    cast: ["主持人：林一鸣", "导师：苏芮", "导师：陈奕辰"],
    duration: "每周五 20:00 更新",
    updateTime: "2025-10-15T22:00:00",
    views: 134500,
    featured: true,
  },
  {
    id: "w-3002",
    title: "向往的山野",
    enTitle: "Longing for the Wild",
    type: "variety",
    genre: ["真人秀", "生活"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Slow%20life%20reality%20variety%20poster%2C%20friends%20cooking%20and%20laughing%20around%20a%20bonfire%20at%20a%20mountain%20cabin%20at%20dusk%2C%20warm%20golden%20light%2C%20cozy%20cinematic%20composition&width=600&height=900&seq=txw-wild-cover-14&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Peaceful%20mountain%20homestead%20at%20golden%20hour%20with%20a%20cozy%20cabin%2C%20garden%20and%20distant%20misty%20hills%2C%20warm%20golden%20tones%2C%20cinematic%20lifestyle%20wide%20shot&width=1600&height=900&seq=txw-wild-poster-14&orientation=landscape",
    summary:
      "一群好朋友来到山里的小院，远离城市的喧嚣，自己种菜、做饭、看星星。慢下来的日子里，藏着你我都向往的生活模样。",
    director: "生活纪事组",
    cast: ["常驻嘉宾：何老师", "常驻嘉宾：张一舟", "常驻嘉宾：月月"],
    duration: "每周六 12:00 更新",
    updateTime: "2025-10-13T18:20:00",
    views: 121300,
    featured: false,
  },
  {
    id: "w-3003",
    title: "喜剧之王现场",
    enTitle: "Live: King of Comedy",
    type: "variety",
    genre: ["喜剧", "舞台"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Comedy%20stage%20show%20variety%20poster%2C%20comedian%20holding%20a%20microphone%20under%20a%20bright%20warm%20spotlight%2C%20playful%20expression%2C%20vivid%20red%20and%20orange%20stage%20lighting%2C%20energetic%20composition&width=600&height=900&seq=txw-comedy-cover-15&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20lit%20comedy%20stage%20with%20a%20single%20microphone%20and%20red%20curtains%2C%20playful%20spotlight%20beams%2C%20vibrant%20crimson%20and%20orange%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-comedy-poster-15&orientation=landscape",
    summary:
      "全国顶尖喜剧人同台竞技，用段子讲述普通人的喜怒哀乐。没有剧本，只有最真实的生活观察与最敢说的犀利表达，笑声背后全是共鸣。",
    director: "欢乐剧场制作组",
    cast: ["主持人：大飞", "喜剧人：小艾", "喜剧人：老王"],
    duration: "每周日 21:00 更新",
    updateTime: "2025-10-12T21:30:00",
    views: 109800,
    featured: false,
  },
  {
    id: "w-3004",
    title: "跳动的厨房",
    enTitle: "Kitchen in Motion",
    type: "variety",
    genre: ["美食", "竞技"],
    region: "中国大陆",
    year: 2024,
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=Cooking%20competition%20variety%20poster%2C%20chef%20flipping%20a%20pan%20with%20flames%20in%20a%20busy%20kitchen%2C%20steaming%20colorful%20dishes%2C%20warm%20golden%20and%20orange%20tones%2C%20dynamic%20cinematic%20composition&width=600&height=900&seq=txw-kitchen-cover-16&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Bustling%20professional%20kitchen%20with%20steaming%20colorful%20dishes%20and%20warm%20golden%20lighting%2C%20chefs%20working%20with%20energy%2C%20appetizing%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-kitchen-poster-16&orientation=landscape",
    summary:
      "来自各地的民间厨艺高手同场较量，一道菜定胜负。家常味道与创意料理正面碰撞，评委只凭味道说话，每一口都可能是通往冠军的关键。",
    director: "美食频道制作组",
    cast: ["主持人：程玥", "主厨评委：黄师傅", "主厨评委：米其林阿伦"],
    duration: "全 24 期",
    updateTime: "2025-05-20T19:00:00",
    views: 84600,
    featured: false,
  },
  {
    id: "w-3005",
    title: "出发吧少年",
    enTitle: "Go, Youth!",
    type: "variety",
    genre: ["旅行", "真人秀"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%2C%20group%20of%20young%20friends%20with%20backpacks%20at%20a%20scenic%20mountain%20overlook%20at%20sunrise%2C%20warm%20orange%20and%20rose%20sky%2C%20adventurous%20cinematic%20composition&width=600&height=900&seq=txw-go-cover-17&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Scenic%20mountain%20road%20trip%20at%20sunrise%2C%20winding%20highway%20through%20misty%20peaks%2C%20warm%20orange%20and%20rose%20sky%2C%20adventurous%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-go-poster-17&orientation=landscape",
    summary:
      "六位少年用有限的预算完成一段横跨祖国山河的旅程。没有剧本，只有一次次说走就走的选择，和路上遇见的每一个温暖的陌生人。",
    director: "远行工作室",
    cast: ["少年团：阿泽", "少年团：小满", "少年团：乐乐"],
    duration: "每周四 20:00 更新",
    updateTime: "2025-10-11T20:00:00",
    views: 78200,
    featured: false,
  },
  {
    id: "w-3006",
    title: "脑力大爆炸",
    enTitle: "Brain Blast",
    type: "variety",
    genre: ["益智", "竞技"],
    region: "中国大陆",
    year: 2024,
    rating: 7.7,
    cover:
      "https://readdy.ai/api/search-image?query=Intelligence%20game%20show%20variety%20poster%2C%20a%20contestant%20thinking%20in%20front%20of%20a%20glowing%20puzzle%20wall%2C%20warm%20amber%20and%20orange%20digital%20lights%2C%20futuristic%20cinematic%20composition&width=600&height=900&seq=txw-brain-cover-18&orientation=portrait",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20game%20show%20set%20with%20glowing%20puzzle%20screens%20and%20warm%20amber%20light%2C%20dramatic%20studio%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=txw-brain-poster-18&orientation=landscape",
    summary:
      "国内首档大型脑力竞技真人秀，顶尖学霸与民间高手在层层谜题中一决高下。烧脑、紧张、反转不断，见证人类大脑的极限魅力。",
    director: "智造传媒",
    cast: ["主持人：吴迪", "嘉宾：李教授", "嘉宾：秦博士"],
    duration: "全 20 期",
    updateTime: "2025-04-15T21:00:00",
    views: 66900,
    featured: false,
  },
];